import * as React from 'react';
export const arrowDownSvg = React.forwardRef(function arrowDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M.97 7.28a.75.75 0 0 1 1.06-1.06l3.22 3.22V.75a.75.75 0 0 1 1.5 0v8.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.747.747 0 0 1-1.06 0l-4.5-4.5Z',
    }),
  );
});
arrowDownSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowDown = {
  category: 'icon',
  colorable: true,
  name: 'arrowDown',
  svg: arrowDownSvg,
};
